import "./App.css";
import React from "react";
import Layout from "./layout/main/MainLayout";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import ScrollToTop from "./widgets/scrollToTop";
import { ToastContainer } from "react-toastify";
import Auth from "./pages/Auth/Auth";
import MedicalPractices from "./pages/MedicalPractices/MedicalPractices";
import MailJet from "./pages/MailJet/MailJet";
import Users from "./pages/Users/Users";
import ChangePassword from "./components/ChangePassword";
import "react-toastify/dist/ReactToastify.css";
import Welcome from "./pages/Welcome";
import Reports from "./pages/Reports";
import CancelledSurvey from "./pages/CancelSurvey/CancelledSurvey";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ToastContainer />
      <Routes>
        <Route path="/authorization-code/callback">
          <Route index element={<Auth />} />
        </Route>
        <Route path="/welcome">
          <Route index element={<Welcome />} />
        </Route>
        <Route path="/" element={<Layout />}>
          <Route path="/practices" element={<MedicalPractices />} />
          <Route path="/users" element={<Users />} />
          <Route path="/mailjet" element={<MailJet />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/cancelled-survey" element={<CancelledSurvey />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
